import { ChartModalComponent } from './../chart-modal/chart-modal.component';
import { WbsService } from './../services/wbs.service';
import { Component, OnInit } from '@angular/core';
import { TreeNode, DialogService } from 'primeng/api';
import { RequestBuilder } from '../classes/request-builder';
import { AlertUtil } from '../utils/alert-util';
import { ICommessa } from '../interfaces/ICommessa';
import * as Enum from '../utils/enums';
import { Loading } from '../utils/loading';
import { CommessaService } from '../services/commessa.service';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-wbs',
  templateUrl: './wbs.component.html',
  styleUrls: ['./wbs.component.css']
})
export class WbsComponent implements OnInit {

  nodes: TreeNode[] = []
  selectedNode: TreeNode;
  commesse: any[]  // table data source

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  L = Loading                     //export loading for html

  rowSelected: boolean = false    //determines whether one commessa row has been clicked

  constructor(private wbsService: WbsService,
    private alertUtil: AlertUtil,
    private commessaService: CommessaService,
    private translate: TranslateService,
    public dialogService: DialogService) { }

  ngOnInit() {
    setTimeout(() => {
      this.getAllCommesse()
    }, 0);
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.commessaService.getAllCommesse(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.commesse = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey ="LBL_HTTP_ERROR_0"
        if(error.status){
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * callback fired when one commessa row is selected
   * @param commessa
   */
  onCommessaRowSelected(commessa: ICommessa) {
    Loading.isLoading = true
    this.rowSelected = true
    this.getAllWbs(commessa)
  }

  /**
   * callback fired when one commessa row is unselected
   */
  onCommessaRowUnselected() {
    this.rowSelected = false
  }


  /**
   * get all wbs list service
   */
  getAllWbs(commessa: ICommessa) {
    let requestBuilder = new RequestBuilder({ Id: commessa.Id })
    this.wbsService.getWbsData(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response.data) {
        this.buildTree(response.data);
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    });
  }

  /**
   * one node select event
   */
  nodeSelect(event: any) {
    if (event.node.label == "Root") {
      //console.log("ROT " + event);
    } else {
      this.openChartModal()
    }
  }

  /**
   * build tree from commessa
   * @param commessa 
   */
  buildTree(commessa: ICommessa) {
    if (commessa.Aggiudicatario) {
      this.nodes = []
      // get tree nodes recursively
      this.getTreeNode(commessa.Aggiudicatario)
    }
  }

  /**
   * get tree node recursively
   * @param curElement 
   * @param nodeParent 
   */
  getTreeNode(curElement: any, nodeParent?: any) {
    if (curElement) {
      //create current tree node
      let child = {
        label: curElement.Ragione_sociale,
        type: nodeParent ? 'esecutore' : 'aggiudicatario_filiera',   //node parent undefined means this node is root and then this node is aggiudicatario
        expanded: false,
        data: curElement,
        children: []
      }

      if (curElement.Esecutori && curElement.Esecutori.length > 0) {
        // build esecutori recursively 
        curElement.Esecutori.forEach(esecutoreChild => {
          this.getTreeNode(esecutoreChild, child)
        })
      }

      if (curElement.Persone && curElement.Persone.length > 0) {
        //   // insert persona node into persona container
        let personaChild = {
          label: "PERSONE",
          type: 'persona',
          expanded: false,
          data: curElement.Persone,
          children: []
        }
        child.children.push(personaChild)
      }

      if (curElement.Mezzi && curElement.Mezzi.length > 0) {
        let mezzoChild = {
          label: "MEZZI",
          type: 'mezzo',
          expanded: false,
          data: curElement.Mezzi,
          children: []
        }
        // insert mezzo node into mezzi container
        child.children.push(mezzoChild)
        // });
      }
      //push child element into node parent if exists, push into nodes otherwise (first element)
      if (nodeParent) {
        nodeParent.children.push(child)
      }
      else {
        this.nodes.push(child)
      }
    }
  }

  /**
   * open new page with link address
   * @param commessa 
   */
  goToGISPage(commessa: ICommessa) {
    window.open(commessa.LinkGIS, "_blank");
  }

  /**
   * Open modal of chart
   */
  openChartModal() {
    this.translate.get("MENU_WBS").subscribe(res => {
      let ref = this.dialogService.open(ChartModalComponent, {
        header: res,
        width: '80%'
      });
    })
  }
}